import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { AppConfigService } from '../../../../framework/services/app-config.service';

@Component({
  selector: 'app-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.css']
})
export class LanguageSelectionComponent implements OnInit {
  languageList:SelectItem[];
  constructor(private appConfigService: AppConfigService) { }

  ngOnInit(): void {
     this.appConfigService.getLanguageList().subscribe((response: any) => {
       if (response) {
         this.languageList = response.map(x => ({
           label: x.name,
           value: x.languageId
         }));
       }
     });
  }
}
